'use client';
import { jsx as _jsx } from "react/jsx-runtime";
import { BoxCTA } from '@lichtblick/photon/atoms/box-cta/box-cta';
import { useTracker } from '@lichtblick/tracker';
import { useCallback } from 'react';
import { buildUrl } from '../../helpers';
import styles from './m-column-item.module.css';
export const MColumnItemCTA = ({ link, linkLabel })=>{
    const { trackCustomEvent } = useTracker();
    const linkClickHandler = useCallback(()=>{
        trackCustomEvent({
            customProps: {
                navigation_area: 'Body',
                navigation_element: linkLabel
            },
            eventName: 'navigation'
        });
    }, [
        linkLabel,
        trackCustomEvent
    ]);
    const href = link && buildUrl(link);
    if (!href || !linkLabel) {
        return null;
    }
    return /*#__PURE__*/ _jsx(BoxCTA, {
        as: "a",
        size: "small",
        variant: "neutral-outline",
        href: href,
        className: styles.button,
        onClick: linkClickHandler,
        children: linkLabel
    });
};

//# sourceMappingURL=m-column-item-cta.js.map